module.exports = __webpack_public_path__ + "img/微信图片_20251027135747_1193_62.aaa0048e.jpg";